import React from 'react';


import PatientSuperSearchInput from './PatientSuperSearchInput';
// import PatientSuperSearchTemplate from './PatientSuperSearchTemplate';
import SuperSearchDropdown from 'NewComponents/FormComponents/SuperSearchDropdown/SuperSearchDropdown';
import PatientSuperSearchTemplate from './PatientSuperSearchTemplate';
import CustomLabel from 'Common/CustomLabel/CustomLabel';

const PatientSuperSearch = ({ searchValue, onChange, label, labelRequired, handleSelectedData, disabled = false, mainSearch = false, height = '180px', width = '354px' }) => {
  return (
    <div className='w-full flex flex-col gap-2'>
      {label ? <CustomLabel label={label} required={labelRequired} /> : null}
    <SuperSearchDropdown handleSelectedData={handleSelectedData}  >
      <SuperSearchDropdown.Input>
        <PatientSuperSearchInput
          disabled={disabled}
          searchValue={searchValue}
          mainSearch={mainSearch}
          onChange={onChange}
          handleSelectedData={handleSelectedData}
          identifier='PatientSuperSearch'
          placeholder='Patient Search...'
        />
      </SuperSearchDropdown.Input>
      <SuperSearchDropdown.Container>
        <PatientSuperSearchTemplate
          height={height}
          width={width}
          handleSelectedData={handleSelectedData} identifier='PatientSuperSearch' />
      </SuperSearchDropdown.Container>
    </SuperSearchDropdown>
    </div>
  );
};

export default PatientSuperSearch;
